// test552
(552 && 0);
